// Shared "Point of contact" field group — city / phone / website / email. Purely
// presentational + controlled; consumed by both PartnerBrandCreateWizard
// (step 4) and PartnerBrandEditPage. The owning section heading is provided
// by each surface.
//
// These four are what a partner's funnel footer shows. A blank one renders NOTHING
// on that footer — no empty link, no orphaned separator — and never falls back to
// Phoenix's own details, which would put a Phoenix address on a white-labelled page.
// So leaving a field empty is a supported choice, not an omission to warn about.

import { Input, Label } from "@/design-system/components/ui";

export interface PartnerBrandContactSectionProps {
  city: string;
  phone: string;
  website: string;
  email: string;
  onCityChange: (value: string) => void;
  onPhoneChange: (value: string) => void;
  onWebsiteChange: (value: string) => void;
  onEmailChange: (value: string) => void;
}

export function PartnerBrandContactSection({
  city,
  phone,
  website,
  email,
  onCityChange,
  onPhoneChange,
  onWebsiteChange,
  onEmailChange,
}: PartnerBrandContactSectionProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-space-3">
      <div className="flex flex-col gap-space-1">
        <Label htmlFor="pb-city">City</Label>
        <Input
          id="pb-city"
          value={city}
          onChange={(e) => onCityChange(e.target.value)}
        />
      </div>
      <div className="flex flex-col gap-space-1">
        <Label htmlFor="pb-phone">Phone</Label>
        <Input
          id="pb-phone"
          value={phone}
          onChange={(e) => onPhoneChange(e.target.value)}
        />
      </div>
      <div className="flex flex-col gap-space-1">
        <Label htmlFor="pb-website">Website</Label>
        <Input
          id="pb-website"
          value={website}
          onChange={(e) => onWebsiteChange(e.target.value)}
        />
      </div>
      <div className="flex flex-col gap-space-1">
        <Label htmlFor="pb-email">Email</Label>
        {/* type="text", not type="email": the field is optional, and a native
            email input reports "" for BOTH cleared and malformed, so a browser
            validation bubble would fire on a value the server is happy to store
            and the footer is happy to render as typed. */}
        <Input
          id="pb-email"
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
        />
      </div>
    </div>
  );
}
